module.exports = __webpack_public_path__ + "components/collaborations-header/static/header--huge@2x-00cfb8de3368af59eaa11de8a4a63152.jpg";